"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ReportGeneratorReportCategory_Factory = exports.Date_Factory = void 0;
var Date_Factory_1 = require("./Date_Factory");
Object.defineProperty(exports, "Date_Factory", { enumerable: true, get: function () { return Date_Factory_1.Date_Factory; } });
var ReportGeneratorReportCategory_Factory = /** @class */ (function () {
    function ReportGeneratorReportCategory_Factory() {
    }
    ReportGeneratorReportCategory_Factory.CreateIncoming = function (model) {
        if (!model)
            return model;
        var result = {
            Id: model.Id,
            Name: model.Name,
        };
        return result;
    };
    ReportGeneratorReportCategory_Factory.CreateOutgoing = function (model) {
        if (!model)
            return model;
        var result = {
            Id: model.Id,
            Name: model.Name,
        };
        return result;
    };
    return ReportGeneratorReportCategory_Factory;
}());
exports.ReportGeneratorReportCategory_Factory = ReportGeneratorReportCategory_Factory;
